import OrganizationsTable from './OrganizationsTable';

export { OrganizationsTable };
export default OrganizationsTable;
